import { headers } from "@utils/utils";
const useCuponStore = defineStore("cupon", () => {
  // State
  const cupon = ref({
    id: null,
    nombre: "",
    descripcion: "",
    vencible: false,
    fecha_vencimiento: null,
    imagen: null,
    creador_id: null,
    creador: null,
    codigos: [],
    beneficios: [],
  });
  const cupones = ref([]);

  // Getters

  const draft = computed(() => ({ ...cupon.value }));
  const hasImagen = computed(() => !!cupon.value.imagen);
  const hasBeneficios = computed(() => cupon.value.beneficios.length > 0);
  const hasCodigos = computed(() => cupon.value.codigos.length > 0);

  // methods

  const setCupon = (payload) => {
    if (payload) cupon.value = payload;
  };

  const clear = () => {
    cupon.value = {
      id: null,
      nombre: "",
      descripcion: "",
      vencible: false,
      fecha_vencimiento: null,
      imagen: null,
      creador_id: null,
      creador: null,
      codigos: [],
      beneficios: [],
    };
  };

  const setCupones = (payload) => {
    cupones.value = payload;
  };
  // Actions

  const fetch = (cupon_id) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/cupons/${cupon_id}/fetch-data`)
        .then(({ data }) => {
          setCupon(data);
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const fetchData = (params) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`api/cupons/fetch-data`, params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const guardar = (datos) => {
    let formData = new FormData();

    Object.keys(datos).forEach((key) => {
      if (key === "imagen" && datos[key]) {
        formData.append(key, datos[key]);
      } else if (Array.isArray(datos[key])) {
        datos[key].forEach((item) => formData.append(`${key}[]`, item));
      } else {
        formData.append(key, datos[key]);
      }
    });

    return new Promise((resolve, reject) => {
      if (datos.id) {
        formData.append("_method", "PUT");
        axios
          .post(`/api/cupons/${datos.id}`, formData, { headers })
          .then(({ data }) => {
            setCupon(data);
            resolve(data);
          })
          .catch((e) => reject(e));
      } else {
        axios
          .post("/api/cupons", formData, { headers })
          .then(({ data }) => {
            setCupon(data);
            resolve(data);
          })
          .catch((e) => reject(e));
      }
    });
  };

  const eliminar = (cupon_id) => {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/cupons/${cupon_id}`)
        .then(({ data }) => {
          clear();
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const verificarCodigo = async (codigo, tipo) => {
    try {
      const { data } = await axios.post(`/api/cupons/verificar-codigo`, {
        codigo,
        tipo,
      });
      return data;
    } catch (error) {
      throw error;
    }
  };

  const canjearCodigo = async (codigo, usuario_id) => {
    try {
      const { data } = await axios.post(`/api/cupons/canjear-codigo`, {
        codigo,
        usuario_id,
      });
      return data;
    } catch (error) {
      throw error;
    }
  };

  const  guardarNotaCodigo = async (codigo_id,datos) => {
    try {
      const { data } = await axios.put(
        `/api/codigos/${codigo_id}/actualizar-nota`,
        datos
      );
      return data;
    } catch (error) {
      throw error;
    }
  };

  return {
    cupon,
    cupones,
    draft,
    hasImagen,
    hasBeneficios,
    hasCodigos,
    setCupon,
    setCupones,
    fetch,
    clear,
    fetchData,
    guardar,
    eliminar,
    verificarCodigo,
    canjearCodigo,
    guardarNotaCodigo,
  };
});
export default useCuponStore;
